<template>        
        <v-card :color="formdata.color" light>  
            <v-card-title v-if="formdata.name != ''">            
                <h1 class="display-2">{{formdata.name}}</h1> </br>
                <!-- <code>{{ result }}</code> -->
            </v-card-title>
            <v-container fluid grid-list-xs>
                <v-layout row wrap>                    
                    <keep-alive>
                        <component 
                            :is="formsave" 
                            :dialogmode="false" 
                            :duplicateable="duplicateable"
                            :helptext="helptext"
                            v-on:submitted="onSubmitted"></component>
                    </keep-alive>   
                    <v-flex d-flex :class="(formdata.showmedia) ? 'xs12 lg7' : ''" >
                        <v-layout row wrap>                            
                            <keep-alive>
                                <component :is="formblock"
                                            :color="formdata.mainblock.blocks[0].color"
                                            :title="formdata.mainblock.blocks[0].name"
                                            :columns="formdata.mainblock.blocks[0].columns"
                                            :blockcomponents="formdata.mainblock.blocks[0].blockcomponents"  
                                            :vuexnamespace="formdata.vuexnamespace"
                                ></component>
                            </keep-alive>   
                            <v-flex d-flex xs12 v-if="formdata.showminies">                            
                                <v-layout row wrap>                                
                                    <keep-alive v-for="mini in formdata.minies.blocks" :key="mini.id">
                                        <component :is="formblock" 
                                                    :color="mini.color"
                                                    :title="mini.name"
                                                    :columns="mini.columns"
                                                    :blockcomponents="mini.blockcomponents"
                                                    :vuexnamespace="formdata.vuexnamespace"
                                        ></component>
                                    </keep-alive>   
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex d-flex xs12 lg3 v-if="formdata.showmedia">
                        <v-layout row wrap>                           
                            <keep-alive v-for="media in formdata.media.blocks" :key="media.id">
                                <component :is="formblock"
                                    :color="media.color"
                                    :title="media.name"
                                    :columns="media.columns"
                                    :blockcomponents="media.blockcomponents"
                                    :vuexnamespace="formdata.vuexnamespace"
                                ></component>
                            </keep-alive>                            
                        </v-layout>
                    </v-flex>                    
                </v-layout>
            </v-container>
        </v-card>
</template>
<script>
    import { mapGetters } from 'vuex';
    import formblock from "./FormFormBlock.vue"
    import formsave from "./FormSave.vue"
    
    export default { 
    inject: ['$validator'],
    
    name: "mainform",
    components: {
        formblock:"formblock",
        formsave:"formsave"
    },
    props:[
        'formdata',  
        'values',
        
    ],
    data() {
        return {                   
            formblock:formblock,
            formsave:formsave,
            id: this.$route.params.id
        }
    },
    watch:{
        $route: function(to,from) {
            if(typeof this.$route.params.id != "undefined") {
                this.id = this.$route.params.id
                this.$store.dispatch(this.formdata.vuexnamespace+'/getById',this.id)
            } else {
                this.id=undefined
                this.$store.commit(this.formdata.initmutation)
            }            
        }
    },
    computed: {
       
        result () {
            return this.$store.getters[this.formdata.vuexnamespace+'/dataobject']
        },
        backlink() {
            return this.formdata.backlink
        },
        duplicateable() {
            return this.formdata.duplicateable
        },
        helptext(){
            return this.formdata.helptext
        }
       
    },
    methods: {
        
        onSubmitted(submitted, duplicate){
            if(!submitted) {  
                this.$emit('submitcomplete',false, null) 
                return
            }            
            if(this.errors.any(this.formdata.vuexnamespace)) {
                this.setMessage('422',this.errors.all(this.formdata.vuexnamespace))                            
                return
            }                                    
            if(duplicate) {
                this.result.duplicate=true
            }
            this.$store.dispatch(this.formdata.vuexnamespace+'/postForm',{payload:this.result,id:this.id})
                .then(response=>{    
                    this.setMessage(response.status,"Erfolg! Dateneingabe erfolgreich!")
                    this.$emit('submitcomplete',true, response.data.id)})
                .catch(error => {                    
                    this.setMessage(error.response.status,error.response.data.errors)                    
                    return 
            })                                             
        },
        init() {
            this.$store.dispatch(this.formdata.vuexnamespace+'/getById',this.id)
                .then(response=> {
                    return
                })
                .catch(error=> {                                        
                    this.setMessage(error.response.status,error.response.data.message)  
                    return
                })
        }
    },
    mounted: function() {
        
        this.$store.commit(this.formdata.initmutation)      
        
        if(typeof this.$route.params.id != 'undefined') {            
            this.id = this.$route.params.id
            this.init()            
        } else {
            this.id= undefined                          
        }   
       
    }
    
    
}
</script>